import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";

import { Card } from "../Card";
import { Image } from "../Image";
import { Text } from "../Text";
import { TextTypes } from "../constants";

import "./styles.scss";

export const MemberProfileActivityEntry = ({
  children,
  headerClassName,
  iconAlt,
  iconComponent,
  iconSrc,
  localDateTime,
  subTitle,
  title,
}) => {
  const renderIcon = () => {
    if (iconComponent) {
      return iconComponent;
    } else if (iconSrc) {
      return (
        <Image
          alt={iconAlt}
          className="apti-MemberProfileActivityEntry__ContentContainer__Icon"
          src={iconSrc}
        />
      );
    }

    return <></>;
  };

  return (
    <Card className="apti-CL apti-MemberProfileActivityEntry">
      <div
        className={createClassNameString([
          "apti-MemberProfileActivityEntry__Header",
          headerClassName,
        ])}
        data-public
      >
        <Text type={TextTypes.subtitle}>{title}</Text>
        <p className="apti-MemberProfileActivityEntry__Header__Date">{localDateTime}</p>
      </div>

      <div className="apti-MemberProfileActivityEntry__ContentContainer">
        {renderIcon()}

        <div data-public>
          <Text type={TextTypes.subtitle}>{subTitle}</Text>
          <div>{children}</div>
        </div>
      </div>
    </Card>
  );
};

MemberProfileActivityEntry.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
  headerClassName: PropTypes.string,
  iconAlt: PropTypes.string,
  iconComponent: PropTypes.element,
  iconSrc: PropTypes.string,
  localDateTime: PropTypes.string,
  subTitle: PropTypes.string,
  title: PropTypes.string,
};

MemberProfileActivityEntry.defaultProps = {
  children: <></>,
  headerClassName: undefined,
  iconAlt: "",
  iconComponent: undefined,
  iconSrc: "",
  localDateTime: "",
  subTitle: "",
  title: "",
};
